











































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import { RESURVEY, MOTION, NEW_MOTION, SHOU_HOU, WEI_JUE } from '@/utils/const'

@Component({})
export default class RevisitListAction extends Vue {
	private RESURVEY = RESURVEY
	private MOTION = MOTION
	private NEW_MOTION = NEW_MOTION
	private SHOU_HOU = SHOU_HOU
	private WEI_JUE = WEI_JUE

	@Prop({})
	private row!: any

	@Prop({})
	private authObj!: any

	private get revisitType() {
		return this.row && this.row.revisitType
	}

	private canRevisit(row: any) {
		if (
			!(
				(row.revisitType === SHOU_HOU && this.authObj.ShouHouStart) ||
				(row.revisitType === WEI_JUE && this.authObj.WeiJueStart)
			)
		) {
			return false
		}
		if (row.revisitor) {
			return (
				row.taskStatus < '30' &&
				row.revisitor === this.$store.state.user.userInfo.userId
			)
		}
		return row.taskStatus < '30'
	}

	private getReturnVisitPath(id: string) {
		return `/returnVisit/tasksDetail/${id}`
	}

	private beginTrackRevisit(row: any) {
		this.$multiTab.close('/returnVisit/collectPendingInfo')
		this.$ls.set('pendingTaskId', row.id)
		this.$nextTick(() => {
			this.$multiTab.open('/returnVisit/collectPendingInfo')
		})
	}

	private go2AddTask(row: any) {
		this.$emit('go2AddTask', row)
	}
}
